import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMaseratiComponent } from './simple-icons-maserati.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMaseratiComponent ],
    exports:      [ SimpleIconsMaseratiComponent ],
    bootstrap:    []
})
export class SimpleIconsMaseratiModule {}
